import React, { useContext, useEffect, useRef, useState } from 'react'
import { SignalRContext, SubscribedSymbolsContext } from '../../layout/BaseLayout';
import { feedSymbol } from '../../util/feed';
import Datafeed from './datafeed.js';
import { useLocation } from 'react-router-dom';

const channelToSubscription = new Map();

export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscriberUID,
  lastDailyBar,
) {
  // const parsedSymbol = parseFullSymbol(symbolInfo.full_name);
  const channelString = `0~${'MetaOdds'}~${symbolInfo.full_name}~${symbolInfo.full_name}`;
  const handler = {
    id: subscriberUID,
    callback: onRealtimeCallback,
  };
  let subscriptionItem = channelToSubscription.get(channelString);
  if (subscriptionItem) {
    // Already subscribed to the channel, use the existing subscription
    subscriptionItem.handlers.push(handler);
    return;
  }
  subscriptionItem = {
    subscriberUID,
    resolution,
    lastDailyBar,
    handlers: [handler],
  };
  channelToSubscription.set(channelString, subscriptionItem);
  console.log('[subscribeBars]: Subscribe to streaming. Channel:', channelString);
  // sockt.emit('SubAdd', { subs: [channelString] });
}

export function unsubscribeFromStream(subscriberUID) {
  for (const channelString of channelToSubscription.keys()) {
    const subscriptionItem = channelToSubscription.get(channelString);
    const handlerIndex = subscriptionItem.handlers
      .findIndex(handler => handler.id === subscriberUID);

    if (handlerIndex !== -1) {
      subscriptionItem.handlers.splice(handlerIndex, 1);

      if (subscriptionItem.handlers.length === 0) {
        console.log('[unsubscribeBars]: Unsubscribe from streaming. Channel:', channelString);
        channelToSubscription.delete(channelString);
        break;
      }
    }
  }
}

const Chart = (props) => {
  const location = useLocation();
  const clickedSymbole = location.state?.symbol;
  let signalR = useContext(SignalRContext);
  const chartContainerRef = useRef();
  const [chartRdy, setChartRdy] = useState(false);
  const symbolDrpSelected = useRef(null);
  let symContext = useContext(SubscribedSymbolsContext);

  const getNextMinuteBarTime = (barTime) => {
    const dat = parseInt(barTime) + 60000;
    return dat.toString();
  }
  const getNext5MinuteBarTime = (barTime) => {
    const dat = parseInt(barTime) + 300000;
    return dat.toString();
  }
  const getNext15MinuteBarTime = (barTime) => {
    const dat = parseInt(barTime) + 900000;
    return dat.toString();
  }
  const getNext30MinuteBarTime = (barTime) => {
    const dat = parseInt(barTime) + 1800000;
    return dat.toString();
  }
  const getNext1HoursBarTime = (barTime) => {
    const dat = parseInt(barTime) + 3600000;
    return dat.toString();
  }
  const getNextDailyBarTime = (barTime) => {
    const date = new Date(barTime);
    date.setDate(date.getDate() + 1);
    return date.getTime();
  }

  // const selectDrpItem = (itm) => {
  //   if (itm.symbolName !== symbolDrpSelected.current.symbolName) {
  //     signalR.on('SendMessage', handleLiverate);
  //     // setBidRate(0);
  //     // setAskRate(0);
  //     // setBidColor('');
  //     // setAskColor('');
  //     // setTimeout(() => {
  //     symbolDrpSelected.current = { ...itm };
  //     // setSymbolDrp(0);
  //   }
  // }

  useEffect(() => {
    if (!!symContext) {
      if (!!clickedSymbole) {
        symbolDrpSelected.current = symContext[clickedSymbole.symbolName];
      } else {
        symbolDrpSelected.current = Object.values(symContext)[0];
      }
    }
  }, [symContext, clickedSymbole])

  // useEffect(() => {
  //   if (!!symContext && Object.keys(symContext)?.length > 0) {
  //     let serverTimeZone = !!sessionStorage.getItem('timezone') ? sessionStorage.getItem('timezone') : "";
  //     if (!!serverTimeZone) {
  //       serverTimeZone = JSON.parse(serverTimeZone)?.value;
  //     }
  //     let tvWidget = new window.TradingView.widget({
  //       symbol: `${symbolDrpSelected?.current?.symbolName}=${symbolDrpSelected?.current?.masterSymbolName}=${symbolDrpSelected?.current.symbolDigits}`,
  //       interval: '1',
  //       fullscreen: true,
  //       autosize: true,
  //       load_last_chart: true,
  //       container: `tv_chart_container_${symbolDrpSelected?.current?.symbolName}_${currentTime}`,
  //       datafeed: Datafeed,
  //       library_path: '../../charting_library/',
  //       allow_symbol_change: false,
  //       hideideas: true,
  //       has_weekly_and_monthly: true,
  //       disabled_features: [
  //         'use_localstorage_for_settings',
  //         'header_compare',
  //         'header_settings',
  //         'symbol_search_hot_key',
  //         'header_saveload',
  //         'show_exchange_logos',
  //         'chart_template_storage',
  //         'save_shortcut',
  //         'header_symbol_search',
  //         'symbol_info',
  //         'timezone_menu',
  //         'widget_logo',
  //         'header_screenshot'
  //       ],
  //       timezone: serverTimeZone,
  //       displayedPriceScale: {
  //         timeVisible: true,
  //       },
  //       save_image: false,
  //     });

  //     tvWidget.onChartReady(function () {
  //       if (!chartRdy) {
  //         console.log('chartRdy', new Date().toISOString());

  //         signalR.on('SendMessage', handleLiverate);
  //         setChartRdy(true);
  //       }
  //     });
  //     return () => {
  //       tvWidget.remove();
  //       signalR.off('SendMessage', handleLiverate);
  //     };
  //   }
  // }, [symContext]);


  useEffect(() => {
    if (
      symbolDrpSelected.current &&
      chartContainerRef.current &&
      symContext &&
      Object.keys(symContext).length > 0
    ) {
      const serverTimeZone = JSON.parse(sessionStorage.getItem('timezone') || '{}')?.value || '';
      const tvWidget = new window.TradingView.widget({
        symbol: `${symbolDrpSelected.current.symbolName}=${symbolDrpSelected.current.masterSymbolName}=${symbolDrpSelected.current.symbolDigits}`,
        interval: '1',
        fullscreen: true,
        autosize: true,
        container: 'tv_chart_container', // ID must match the div ID exactly
        datafeed: Datafeed,
        library_path: '../../charting_library/',
        allow_symbol_change: false,
        hideideas: true,
        has_weekly_and_monthly: true,
        disabled_features: [
          'use_localstorage_for_settings',
          'header_compare',
          'header_settings',
          'symbol_search_hot_key',
          'header_saveload',
          'show_exchange_logos',
          'chart_template_storage',
          'save_shortcut',
          'header_symbol_search',
          'symbol_info',
          'timezone_menu',
          'widget_logo',
          'header_screenshot',
        ],
        timezone: serverTimeZone,
        displayedPriceScale: { timeVisible: true },
        save_image: false,
      });
      // tvWidget.onChartReady(() => {
      //   console.log('Chart ready');
      //   signalR.on('SendMessage', handleLiverate);
      //   setChartRdy(true);
      // });
      // return () => {
      //   tvWidget.remove();
      //   signalR.off('SendMessage', handleLiverate);
      // };
      tvWidget.onChartReady(function () {
        // 	var chart = tvWidget.chart();
        // 	chart.onIntervalChanged().subscribe(null, function (resolution) {
        // 		debugger
        // 	});
        if (!chartRdy) {
          console.log('chartRdy', new Date().toISOString());
          signalR.on('SendMessage', handleLiverate);
          setChartRdy(true);
        }
      });
      return () => {
        tvWidget.remove();
        signalR.off('SendMessage', handleLiverate);
      };
    }
  }, [symContext]);

  const handleLiverate = (data) => {
    if ((data.match(/\|/g) || []).length > 2) {
      data = feedSymbol(data)
      if (data.name === symbolDrpSelected.current.symbolName) {
        const tradePrice = parseFloat(data.bid);
        const tradeTime = parseInt(data.time);
        const channelString = `0~${'MetaOdds'}~${data.name}~${data.name}`;
        const subscriptionItem = channelToSubscription.get(channelString);
        if (subscriptionItem === undefined) {
          return;
        }
        const resolution = subscriptionItem.resolution;
        const lastDailyBar = subscriptionItem.lastDailyBar;
        let bar;

        let nextDailyBarTime;
        if (resolution == "1") {
          nextDailyBarTime = parseInt(getNextMinuteBarTime(lastDailyBar.time))
        } else if (resolution == "5") {
          nextDailyBarTime = parseInt(getNext5MinuteBarTime(lastDailyBar.time))
        } else if (resolution == "15") {
          nextDailyBarTime = parseInt(getNext15MinuteBarTime(lastDailyBar.time))
        } else if (resolution == "30") {
          nextDailyBarTime = parseInt(getNext30MinuteBarTime(lastDailyBar.time))
        } else if (resolution == "60") {
          nextDailyBarTime = parseInt(getNext1HoursBarTime(lastDailyBar.time))
        } else {
          nextDailyBarTime = getNextDailyBarTime(lastDailyBar.time);
        }

        if (tradeTime >= nextDailyBarTime) {
          bar = {
            time: nextDailyBarTime,
            open: data.bid,
            high: data.bid,
            low: data.bid,
            close: data.bid,
          };
          console.log('[socket] Generate new bar', bar);
        } else {
          bar = {
            ...lastDailyBar,
            high: Math.max(lastDailyBar.high, tradePrice),
            low: Math.min(lastDailyBar.low, tradePrice),
            close: data.bid,
          };
          console.log('[socket] Update the latest bar by price', data.bid);
        }
        subscriptionItem.lastDailyBar = bar;
        subscriptionItem.handlers.forEach(handler => handler.callback(bar));
      }
    }
  };

  return (
    <>
      <div id={`tv_chart_container`}
        ref={chartContainerRef}
        className={'TVChartContainer'}>
      </div>
    </>
  )

}

export default Chart